import apiService from '../apiService';

const REMINDER_URL = 'reminders';

const reminderService = {

  async createReminder(payload) {
    try {
      const response = await apiService.post(`/${REMINDER_URL}`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async getSingleReminder(id) {
    try {
      const response = await apiService.get(`/${REMINDER_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async updateReminder(payload, id) {
    try {
      const response = await apiService.put(`/${REMINDER_URL}/${id}`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async deleteReminder(id) {
    try {
      const response = await apiService.delete(`/${REMINDER_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async completeReminder(id) {
    try {
      const response = await apiService.post(`/${REMINDER_URL}/${id}/complete`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async reopenReminder(id) {
    try {
      const response = await apiService.post(`/${REMINDER_URL}/${id}/reopen`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  // Dashboard panel — the current user's pending reminders, split overdue/upcoming.
  async getUpcomingReminders(params = {}) {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const response = await apiService.get(`/${REMINDER_URL}/upcoming${queryParams ? `?${queryParams}` : ''}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
};

export default reminderService;
